import React from "react";
import { Navigate } from "react-router-dom";
import { getUser, getToken } from "../../utils/auth";

export default function ProtectedRoute({ children, permission, requireAdmin = true }) {
  const token = getToken();
  const user = getUser();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If admin is required but user is not admin
  if (requireAdmin && !user?.isAdmin) {
    return <Navigate to="/login" replace />;
  }

  // Permission system
  if (permission) {
    let perms = user.permissions || [];
    // Handle if permissions is still a JSON string for some reason
    if (typeof perms === "string") {
      if (perms === '*') perms = ['*'];
      else try { perms = JSON.parse(perms); } catch (e) { perms = []; }
    }

    const hasPerm = (Array.isArray(perms) && perms.includes("*")) || (Array.isArray(perms) && perms.includes(permission));

    if (!hasPerm) {
      return <Navigate to="/admin" replace />;
    }
  }

  return children;
}
